
import Vue from 'vue';
import axios from 'axios';
import Top from '@/components/templates/Top.vue';
import * as action from '@/store/actions';

interface Param {
  key: string;
  value: string;
}

export default Vue.extend({
  name: 'ParamsVoip',
  components: {
    Top,
  },
  data() {
    return {
      params: [] as Param[],
      descriptionsByKey: {
        'mailer_encryption': 'Método de cifrado del correo',
        'mailer_from_address': 'Dirección de remitente',
        'mailer_from_name': 'Nombre de remitente',
        'mailer_host': 'Servidor SMTP',
        'mailer_pass': 'Contraseña SMTP',
        'mailer_port': 'Puerto SMTP',
        'mailer_subject': 'Asunto por defecto',
        'mailer_user': 'Usuario SMTP',
      } as Record<string, string>,
      editableKeys: [
        'mailer_encryption',
        'mailer_from_address',
        'mailer_from_name',
        'mailer_host',
        'mailer_pass',
        'mailer_port',
        'mailer_subject',
        'mailer_user',
      ],
    };
  },
  methods: {
    async fetchParams() {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get<Param[]>(action.GET_ALL_PARAMS_MAIL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Filtrar solo los parámetros editables y mantener orden
        this.params = this.editableKeys.map(key => {
          const found = response.data.find(p => p.key === key);
          return {
            key,
            value: found ? found.value : '',
          };
        });
      } catch (error) {
        console.error('Error al obtener los parámetros:', error);
      }
    },
    async guardarCambios() {
      try {
        await this.$nextTick(); // aseguramos v-model actualizado
        const token = localStorage.getItem('token');

        await axios.post(action.UPDATE_PARAMS_MAIL, this.params, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        this.$emit('snackbar', { color: 'success', text: 'Parámetros guardados correctamente.' });
      } catch (error) {
        console.error('Error al guardar los parámetros:', error);
        this.$emit('snackbar', { color: 'error', text: 'Error al guardar los parámetros.' });
      }
    },
  },
  mounted() {
    this.fetchParams();
  },
});
